(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('contextMenu', ContextMenuDirective);

  function ContextMenuDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/directives/context-menu.html',
      transclude: true,
      scope: {
        visible: '=',
        position: '<'
      },
      link(scope) {
        scope.uniqueId = _.uniqueId('ctx-menu-');
      }
    };
  }
}());
